import PropTypes from "prop-types";
import { useState } from "react";
import Modal from "components/shared/stays/Modal";
import ModalBody from "components/shared/stays/ModalBody";
import ModalHeader from "components/shared/stays/ModalHeader";
import ModalFooter from "components/shared/stays/ModalFooter";
import Button from "solar/components/Button";
import Month from "components/shared/stays/Month";
import Title from "components/shared/stays/Title";
import styles from "components/shared/stays/ChooseMonth.module.scss";

export default function ChooseMonth({
  show,
  handleClose,
  setParentMonth,
  month,
}) {
  const [currentMonth, setCurrentMonth] = useState(month);

  function handleSave() {
    setParentMonth(currentMonth);
    handleClose();
  }

  function clearMonth() {
    setParentMonth(null);
    handleClose();
  }

  return (
    <Modal show={show} handleClose={handleClose}>
      <ModalHeader>
        <Title size={4}>Select a month</Title>
      </ModalHeader>
      <ModalBody>
        <Month initialMonth={month} setCurrentMonth={setCurrentMonth} />
      </ModalBody>
      <ModalFooter bordered>
        <div className={styles.footer}>
          <div>
            <Button link size={2} onClick={clearMonth}>
              Clear dates
            </Button>
          </div>
          <div>
            <Button size={2} onClick={handleSave}>
              Save
            </Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
}

ChooseMonth.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setParentMonth: PropTypes.func.isRequired,
  month: PropTypes.instanceOf(Date),
};

ChooseMonth.defaultProps = {
  month: null,
};
